/** Converts an ISO "yyyy-MM-dd" string to "DD/MM/YYYY" display format, or null when absent/malformed. */
export function formatIsoDate(date: string | null | undefined): string | null {
    if (!date) return null;
    const parts = date.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!parts) return null;
    const [, y, m, d] = parts;
    return `${d}/${m}/${y}`;
}

/**
 * Converts an ISO date-TIME ("yyyy-MM-ddTHH:mm:ss") to "DD/MM/YYYY", or null when absent/malformed.
 *
 * `formatIsoDate` anchors on a date-only string and returns null for anything carrying a time, so it
 * cannot be pointed at a timestamp field: it would report every value as unavailable rather than
 * fail loudly. The Network Table's `created` comes from a `timestamp` column and its endpoint
 * serialises it as "yyyy-MM-ddTHH:mm:ss", which is exactly that case.
 *
 * Date-only input is accepted too, so callers need not know which shape the field carries.
 * The time is discarded rather than rendered — Orbit displays dates as DD/MM/YYYY throughout.
 */
export function formatIsoDateTime(value: string | null | undefined): string | null {
    if (!value) return null;
    const [datePart] = value.split('T');
    return formatIsoDate(datePart);
}
